module.exports = __webpack_public_path__ + "static/img/Avintercoms_back.1a83a2d1.png";